import * as React from "react";
import { useLocation } from "react-router";
import * as analytics from "@/services/analytics";

export const usePageView = () => {
  const location = useLocation();

  React.useEffect(() => {
    analytics.pageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
};
